import { useCallback, useState } from "react"

import { IApiLink } from "@/types"
import AssetCollectionModel from "models/AssetCollection"
import AssetService from "services/AssetService"
import toastMessages from "stores/toastMessages"

const emptyAssetCollection = new AssetCollectionModel({ assets: [] })

export default function useAssetCollection(linkGetAssetCollection?: IApiLink) {
    const [assetCollection, setAssetCollection] = useState<AssetCollectionModel | null>(null)

    const fetchAssetCollection = useCallback(async () => {
        if (!linkGetAssetCollection) {
            setAssetCollection(emptyAssetCollection)
            return emptyAssetCollection
        }
        try {
            const resp = await AssetService.getAssetCollection(linkGetAssetCollection)
            setAssetCollection(resp)
            return resp
        } catch (e) {
            toastMessages.showSystemError()
            setAssetCollection(emptyAssetCollection)
            return emptyAssetCollection
        }
    }, [linkGetAssetCollection])

    return {
        assetCollection,
        fetchAssetCollection,
    }
}
